import { render, staticRenderFns } from "./HouseTypeInfo.vue?vue&type=template&id=2ae5d7ea&scoped=true&"
import script from "./HouseTypeInfo.vue?vue&type=script&lang=js&"
export * from "./HouseTypeInfo.vue?vue&type=script&lang=js&"
import style0 from "./HouseTypeInfo.vue?vue&type=style&index=0&id=2ae5d7ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae5d7ea",
  null
  
)

export default component.exports